import {AfterViewInit, Directive, ElementRef, HostBinding, HostListener, Input} from '@angular/core';
import {MediaPreviewService} from './media-preview.service';

@Directive({
    selector: '[lightbox]',
    standalone: false
})
export class ImagePreviewDirective implements AfterViewInit {
  @Input() lightbox: string;
  @HostBinding('style.cursor') cursor = 'pointer';

  constructor(
      private readonly mediaPreviewService: MediaPreviewService,
      private readonly el: ElementRef,
  ) {}

  ngAfterViewInit() {
    if (!this.lightbox) {
      this.lightbox = this.el.nativeElement.src;
    }
  }

  @HostListener('click')
  clickHandler() {
    this.mediaPreviewService.previewImage(this.lightbox);
  }
}
